//
// tracking.js - google analytics helper
//


function get_tracker() {
  if (window.ga && window.ga.getAll) {
    let trackers = window.ga.getAll();
    if (trackers.length) {
      return trackers[0];
    }
  }
  return null;
}


// pageview()
// -----------------------------

function pageview(location) {
  location = location || window.location.pathname;

  let tracker = get_tracker();
  if (tracker) {
    tracker.send('pageview', location);
  }
}


export {
  pageview,
};

